import {useEffect, useRef, useState} from "react";
import {useOnScreen} from "../hooks/useOnScreen";
import {RoundedCustomButton} from "./CustomIcon";

const ScrollLayoutDynamicArrow = ({
                                    className,
                                    children, scrollDistance = 0, classNav = "mx-3",
                                    id,
                                    showNav = false,
                                    isDefaultVisible = true,
                                    isNavOverlay = false
                                  }) => {

  const scrollRef = useRef();
  //this is for getting the size of hidden elements when their visibility is turned on from the off state
  const parentRef = useRef();
  const isVisible = useOnScreen(parentRef, isDefaultVisible);

  const [canBeScrolledRight, setCanBeScrolledRight] = useState(false);
  const [canBeScrolledLeft, setCanBeScrolledLeft] = useState(false);
  const [hasScrollBar, setHasScrollBar] = useState(false);
  const handleScroll = (e) => {
    setScrollProperties(e.target);
  };

  const setScrollProperties = (element) => {
    if (element.offsetWidth + element.scrollLeft >= element.scrollWidth) {
      setCanBeScrolledRight(false);
    } else {
      setCanBeScrolledRight(true);
    }

    if (element.scrollLeft <= 0) {
      setCanBeScrolledLeft(false);
    } else {
      setCanBeScrolledLeft(true);
    }
  };

  useEffect(() => {

    if (isVisible && scrollRef?.current) {
      setHasScrollBar(scrollRef.current.scrollWidth > scrollRef.current.clientWidth);
      setScrollProperties(scrollRef?.current);
    }

  }, [isVisible]);

  const scrollManually = (offset) => {
    if (!!scrollRef.current?.scrollLeft || scrollRef.current?.scrollLeft === 0)
      // scrollRef.current.scrollLeft = scrollRef.current.offsetWidth + scrollRef.current.scrollLeft;
      scrollRef.current.scrollTo({
        top: 0,
        left: Math.min((offset * scrollRef.current.offsetWidth) + scrollDistance + scrollRef.current.scrollLeft, scrollRef.current.scrollWidth),
        behavior: 'smooth'
      });
  };

  return (
    <div className="flex items-center w-full relative" ref={parentRef}>
      {(showNav && hasScrollBar && (!isNavOverlay || (canBeScrolledLeft && isNavOverlay))) && <RoundedCustomButton size="2xl"
                                                         disabled={!canBeScrolledLeft}
                                                         className={`hidden lg:block left-arrow ${isNavOverlay ? "shadow-md shrink-0 absolute z-10 -left-12 mx-0" : ""} ${classNav ? ` ${classNav}` : ''}`}
                                                         icon="chevron_left" onClick={() => scrollManually(-1)}/>}

      <div className={`flex-grow horizontal${className ? ` ${className}` : ''}`} ref={scrollRef} id={id}
           onScroll={handleScroll}>
        {children}
      </div>

      {(showNav && hasScrollBar&& (!isNavOverlay || (canBeScrolledRight && isNavOverlay))) && <RoundedCustomButton size="2xl"
                                                         disabled={!canBeScrolledRight}
                                                         className={`hidden lg:block right-arrow ${isNavOverlay ? "shadow-md shrink-0 absolute z-10 -right-12 mx-0" : ""} ${classNav ? ` ${classNav}` : ''}`}
                                                         icon="chevron_right"
                                                         onClick={() => scrollManually(1)} isLeft={false}/>}
    </div>
  );


};

export default ScrollLayoutDynamicArrow;


